import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type UnpublishCampaignFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  errorCode: string
}>

const errorCodesMap = {
  'giving_campaigns/wrong_state': 'errorMessage.manageGivingCampaigns.wrongState'
} as const

export function UnpublishCampaignFailureModal({ isOpen, errorCode, handleClose }: UnpublishCampaignFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="unpublish-campaign-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.givingCampaigns.unpublishCampaign.failure.title')}
        description={t(errorCodesMap[errorCode] ?? 'errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
